import React,{useState,useEffect,useRef} from 'react';
import '../../CSS/index.css';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { getList } from '../../Utils/FormCalls';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';
import { RBSPREDMODEL } from '../../../../commons/api';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import StyledTable from '../../../../commons/styles/table';

const APIList = {
  getList: `${RBSPREDMODEL.ModelWorkBenchList}`
};
const ModelsWorkbench = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? [...response] : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
        {/* <Button
          type="link"
          
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
            this.setState({
              searchText: selectedKeys[0],
              searchedColumn: dataIndex,
            });
          }}
        >
          Filter
        </Button> */}
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const columns = [
    {
      title: translation('Name'),
      dataIndex: 'ModelName',
      key: 'ModelName',
      ...getColumnSearchProps('ModelName'),
      sorter: (a, b) => a.ModelName.localeCompare(b.ModelName)
    },
    {
      title: translation('Type'),
      dataIndex: 'ModelType',
      key: 'ModelType',
      ...getColumnSearchProps('ModelType'),
      sorter: (a, b) => a.ModelType.localeCompare(b.ModelType)
    },
    {
      title: translation('Group'),
      dataIndex: 'ModelGroup',
      key: 'ModelGroup',
      ...getColumnSearchProps('ModelGroup'),
      sorter: (a, b) => a.ModelGroup.localeCompare(b.ModelGroup)
    },
    {
      title: translation('Created By'),
      key: 'CreatedName',
      dataIndex: 'CreatedName',
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) =>
        a.CreatedName && b.CreatedName && a.CreatedName.localeCompare(b.CreatedName)
    },
    {
      title: translation('Created Date'),
      key: 'CreatedTime',
      dataIndex: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) => new Date(a.CreatedTime) - new Date(b.CreatedTime),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Enabled'),
      dataIndex: 'Enabled',
      key: 'Enabled',
      ...getColumnSearchProps('Enabled'),
      sorter: (a, b) => String(a.Enabled).localeCompare(String(b.Enabled)),
      render: (text) => String(text)
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchProps('Status'),
      sorter: (a, b) => a.Status.localeCompare(b.Status)
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <Tooltip
          title={
            record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Open Details')
              : translation('Click to Register')
          }
        >
          <a
            style={{ marginRight: '5px' }}
            onClick={() => props.navigate(`/rubus/RbsAnalytics/ModelDetails/${record.ModelId}`)}
          >
            {record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Details')
              : translation('Register')}
          </a>
        </Tooltip>
      )
    }
  ];
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={translation('Click here to register a new model')}>
            <Button
              onClick={() => props.navigate('/rubus/RbsAnalytics/ModelRegistration')}
              type="primary"
              style={{
                marginBottom: 8
              }}
              
            >
              {translation('Register New')}
            </Button>
          </Tooltip>
        </div>
        <StyledTable size="small"
          data-testid="workbenchList"
          theme={themeSettings}
          dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
          columns={columns}
       />
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ModelsWorkbench);
